import { getProductInventoryDelivery } from './get-product-inventory-delivery.js';

const defaultDeliveryResolver = (config, availability1 = [])=>availability1.map((availability)=>getProductInventoryDelivery(config, availability)
    )
;

export { defaultDeliveryResolver };
//# sourceMappingURL=default-delivery-resolver.js.map
